import script from "./FranchiseDayOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDayOrders.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import FranchiseDayBottleList from "@/components/franchise/FranchiseDayBottleList.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
script.components = Object.assign({}, { BasicSpinner, FranchiseDayBottleList, NeueButton }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, FranchiseDayBottleList, NeueButton }, script.__o.components);}